import { render } from "./MailingList.vue?vue&type=template&id=db8fe662&scoped=true"
import script from "./MailingList.vue?vue&type=script&lang=js"
export * from "./MailingList.vue?vue&type=script&lang=js"

import "./MailingList.vue?vue&type=style&index=0&id=db8fe662&scoped=true&lang=css"

import exportComponent from "D:\\projects\\RED MENACE\\redmenacegames.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db8fe662"]])

export default __exports__